import { Employee } from '../../core/services/employee.model';
import { SearchResult } from '../../features/search/search.model';

/**
 * Map an Employee record to the SearchResult shape that `IdAutocompleteComponent`
 * renders. Used by every employee/agent typeahead so the row layout stays uniform:
 *
 *   `<id> · <First Last> (login) · <location> · <team>`
 *
 * The `accent` slot ("(login)") shares the foreground color of the name —
 * it reads as part of the identity. The `subline` ("location · team") is
 * rendered muted and truncates first under width pressure.
 */
export function employeeToHit(e: Employee): SearchResult {
  const name = `${e.firstName ?? ''} ${e.lastName ?? ''}`.trim();
  const subline = [e.location, e.team]
    .filter((p): p is string => !!p)
    .join(' · ');
  return {
    brand: '',
    customerId: '',
    companyName: '',
    firstName: e.firstName ?? '',
    lastName: e.lastName ?? '',
    category: 'employee',
    detail: name,
    externId: '',
    status: e.terminated ? 'inactive' : 'active',
    entityType: 'employee',
    entityId: String(e.id),
    accent: e.login ? `(${e.login})` : undefined,
    subline: subline || undefined,
  };
}
